import { z } from "zod";
import type { GlassVariant, Product } from "../types/product";

const opTierSchema = z.object({ maxMm: z.number(), cost: z.number() });

const variantOpsSchema = z.object({
  slijpPerM: z.number().optional(),
  boring: z.array(opTierSchema).optional(),
  uitsparing: z.array(opTierSchema).optional(),
  hoek: z.array(opTierSchema).optional(),
});

const sizeSurchargeSchema = z.object({ fromM2: z.number(), pct: z.number() });
const shapeSchema = z.object({ id: z.string(), name: z.string(), surchargePct: z.number() });

/** Validates a glass variant (used by the Timmers sync in Fase 4). */
export const glassVariantSchema = z.object({
  id: z.string(),
  name: z.string(),
  thicknessMm: z.number(),
  pricePerM2: z.number(),
  minAreaM2: z.number(),
  maxWidthMm: z.number(),
  maxHeightMm: z.number(),
  weightPerM2: z.number().optional(),
  grindingRequired: z.boolean().optional(),
  subcategory: z.string().optional(),
  finish: z.string().optional(),
  color: z.string().optional(),
  shapes: z.array(z.string()).optional(),
  ops: variantOpsSchema.optional(),
  vormen: z.array(shapeSchema).optional(),
  sizeSurcharges: z.array(sizeSurchargeSchema).optional(),
  energyPerKg: z.number().optional(),
  imageUrl: z.string().optional(),
  timmersDiscountPct: z.number().optional(),
  showerPricePerM2: z.number().optional(),
});

const productSpecsSchema = z.object({
  uValue: z.string().optional(),
  ltaValue: z.string().optional(),
  ztaValue: z.string().optional(),
  soundInsulation: z.string().optional(),
});

/** Validates a catalogue product (used by the Timmers sync in Fase 4). */
export const productSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  type: z.enum(["configurable", "article"]),
  timmers_category_path: z.array(z.string()),
  category: z.string(),
  description: z.string().optional(),
  images: z.array(z.string()),
  specs: productSpecsSchema.optional(),
  price: z.number().optional(),
  stock: z.number().optional(),
  variants: z.array(glassVariantSchema).optional(),
  subcategories: z.array(z.string()).optional(),
  shapes: z.array(z.string()).optional(),
});

// Compile-time drift guards against the hand-written domain types.
const _assertVariant: (x: z.infer<typeof glassVariantSchema>) => GlassVariant = (
  x,
) => x;
const _assertProduct: (x: z.infer<typeof productSchema>) => Product = (x) => x;
void _assertVariant;
void _assertProduct;
